
import { IS_PUBLIC_ACCESS_RESTRICTED_KEY } from '@/constants/constants';

import FillingInformation from '@/views/Registration/FillingInformation/index.vue';
import EmailVerification from '@/views/Registration/EmailVerification/index.vue';
import CardActivation from '@/views/Registration/CardActivation/index.vue';
import RegistrationSuccess from '@/views/Registration/Success/index.vue';


export default [
  {
    path: '/registration',
    redirect: '/registration/email-verification',
    meta: {
      [IS_PUBLIC_ACCESS_RESTRICTED_KEY]: true,
      titleType: 'registration',
    },
  },

  {
    path: '/registration/email-verification',
    name: 'EmailVerification',
    component: EmailVerification,
    meta: {
      titleType: 'registration',
    },
  },

  {
    path: '/card-activation',
    name: 'CardActivation',
    component: CardActivation,
    meta: {
      titleType: 'cardActivation',
    },
  },

  {
    path: '/registration/filling-information',
    name: 'FillingInformation',
    component: FillingInformation,
    meta: {
      titleType: 'registration',
    },
  },

  {
    path: '/registration/success',
    name: 'RegistrationSuccess',
    component: RegistrationSuccess,
    meta: {
      titleType: 'congratulations',
    },
  },
];
